import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { AuthService } from '@services/auth.service';
import { HttpService } from '@services/http.service';
import { ErrorService } from '@services/error.service';
import { DialogService } from '@services/dialog.service';

import { User } from '@models/user';

@Component({
  selector: 'app-ftp-info',
  templateUrl: './ftp.component.html',
  styleUrls: ['./ftp.component.scss'],
  standalone: false
})
export class DataManagementFtpComponent implements OnInit {

  public currentUser: User | null = null;
  public ftpInfo: any;
  public resettingFtpPassword: boolean = false;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private authService: AuthService,
    private httpService: HttpService,
    private errorService: ErrorService,
    private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.authService.getCurrentUser$().subscribe((user: (User | null)) => {
      this.currentUser = user;
    });

    this.getFtpInfo();
  }

  private getFtpInfo() {
    return this.httpService.get(`**/users/ftp-info`).then((ftpInfo: any) => {
      this.ftpInfo = ftpInfo;
    }).catch((error: any) => {
      this.errorService.printError(error);
    });
  }

  public copyToClipBoard(event: any, value: string) {
    const el = document.createElement('textarea');
    el.value = value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    const element = event.target as HTMLElement;
    element.classList.add('copied');
    setTimeout(() => {
      element.classList.remove('copied');
    }, 1000);
  }

  public async resetFtpPassword() {
    if (! await this.dialogService.confirm(
      'FTP-Zugang zurücksetzen',
      'Möchten Sie wirklich Ihr FTP-Passwort zurücksetzen? Ihr Passwort wird auf ein zufälliges Passwort zurückgesetzt. Sie können das Passwort jederzeit erneut Einstellungen ändern.',
      this.viewContainerRef
    )) {
      return;
    }

    this.resettingFtpPassword = true;

    this.httpService.post(`**/users/reset-ftp-password`).then(() => {
      return this.authService.refreshUser();
    }).then(() => {
      this.resettingFtpPassword = false;

      this.dialogService.alert(null, "Ihr FTP-Passwort wurde erfolgreich zurückgesetzt. Sie können das neue Passwort auf der Startseite einsehen.", 'success');
    }).catch((error: any) => {
      this.resettingFtpPassword = false;
      this.errorService.printError(error);
    });
  }

}
